angular.module 'zc.projects'

.controller 'ClearanceSetShowCtrl', ($scope, $translate, Page, clearanceItemSet, currentProject) ->
  Page.setBodyClass ''
  $translate('projectsClearance.clearanceSetShow.campaignSettingDetail').then (translation) ->
    Page.setTitle translation

  $scope.project = currentProject
  $scope.clearanceItemSet = clearanceItemSet



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.clearance/clearance_set_show.controller.coffee